module.exports = __webpack_public_path__ + "static/media/sidebar.8336c4e9.jpg";